import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { UserRead } from '../types/api';

interface AppHeaderProps {
  user?: UserRead | null;
  onLogin?: () => void;
  onLogout?: () => void;
  onLogoClick?: () => void;
  title?: string;
  variant?: 'full' | 'minimal';
  showBackButton?: boolean;
  onBackClick?: () => void;
  backButtonText?: string;
}

export const AppHeader: React.FC<AppHeaderProps> = ({
  onLogoClick,
  title,
  variant = 'full',
  showBackButton = false,
  onBackClick,
  backButtonText = "Back"
}) => {
  const isMinimal = variant === 'minimal';
  const containerClass = isMinimal
    ? 'max-w-md mx-auto px-6 lg:max-w-7xl lg:px-8'
    : 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8';

  return (
    <header className={`bg-white ${!isMinimal ? 'lg:hidden' : ''}`}>
      <div className={containerClass}>
        <div className={`flex items-center h-16 ${isMinimal ? '' : 'justify-center'}`}>
          {/* Logo / Back + Title */}
          <div className="flex items-center space-x-3">
            {showBackButton && onBackClick && (
              <button
                onClick={onBackClick}
                className="flex items-center text-gray-600 hover:text-gray-800 transition-colors p-2 rounded-md hover:bg-gray-100"
                title={backButtonText}
              >
                <ArrowLeft size={20} />
              </button>
            )}

            {isMinimal ? (
              title ? (
                <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
              ) : null
            ) : (
              <button
                onClick={onLogoClick}
                className="flex items-center gap-2 hover:opacity-80 transition-opacity"
              >
                <img
                  src="/logo topbred 1.png"
                  alt="TopBred"
                  className="h-8 w-8 object-contain"
                />
                <span
                  className="text-black text-2xl tracking-wide flex items-center pt-1.5"
                  style={{ fontFamily: 'Azonix, sans-serif' }}
                >
                  TOPBRED
                </span>
              </button>
            )}
          </div>

        </div>
      </div>
    </header>
  );
};
